const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const MarketableOperationOKButton = require('components/broker/commons/marketableOperationOKButton/marketableOperationOKButton');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @actions
const BrokerPensionPlanContributionActions = require('actions/brokerPensionPlanContribution');

class BrokerPlanContributionButton extends React.Component {
    constructor(props) {
        super(props);
        this.handleExtraordinaryContribution = this.handleExtraordinaryContribution.bind(this);
        this.handlePeriodicContribution = this.handlePeriodicContribution.bind(this);
    }

    handleExtraordinaryContribution() {
        const { history, onClick, planId, contractNumber, productName, pageName } = this.props;

        if (onClick) {
            onClick(contractNumber);
            taggingEventHandled(pageName, 'actionButtonMenu', productName, 'extraordinary' );
            history.push(`/myprofile/broker/pensionPlansContribution/${planId}`);
        }
    }

    handlePeriodicContribution() {
        const { history, onClick, planId, contractNumber, productName, pageName } = this.props;

        if (onClick) {
            onClick(contractNumber);
            taggingEventHandled(pageName, 'actionButtonMenu', productName, 'periodic' );
            history.push(`/myprofile/broker/pensionPlansPeriodicContribution/${planId}`);
        }
    }

    render() {
        const targetElement = (
            <MarketableOperationOKButton modifier="secondary" size="small" disabled={this.props.disabled}>
                <FormattedText value="broker-myInvestmentsPensionPlanContribution"/>
            </MarketableOperationOKButton>
        );

        const options = [
            {
                text: formatText('broker-myInvestmentsPensionPlanExtraordinaryContribution'),
                handleClick: () => this.handleExtraordinaryContribution()
            },
            {
                text: formatText('broker-myInvestmentsPensionPlanPeriodicContribution'),
                handleClick: () => this.handlePeriodicContribution()
            }
        ];

        return (
            <PopoverMenu target={targetElement} items={options} placement="bottomRight" />
        );
    }
}

BrokerPlanContributionButton.defaultProps = {
    disabled: false
}

BrokerPlanContributionButton.propTypes = {
    history: PropTypes.object.isRequired,
    planId: PropTypes.string.isRequired,
    contractNumber: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    finalType: PropTypes.string,
    productName: PropTypes.string,
    pageName: PropTypes.string
};

module.exports.constructor = BrokerPlanContributionButton;
module.exports.BrokerPlanContributionButton = connect(null, {
    onClick: BrokerPensionPlanContributionActions.setContractNumber
})(withRouter(BrokerPlanContributionButton));
